import { render } from "./AdicionarEmpresaGrupoModal.vue?vue&type=template&id=2226123b&scoped=true&ts=true"
import script from "./AdicionarEmpresaGrupoModal.vue?vue&type=script&lang=ts"
export * from "./AdicionarEmpresaGrupoModal.vue?vue&type=script&lang=ts"

import "./AdicionarEmpresaGrupoModal.vue?vue&type=style&index=0&id=2226123b&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2226123b"]])

export default __exports__